"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    APP_ROOT: 'profile',
    PAYPAL_URI: '/',
    LEGACY_SETTINGS_URI: '/myaccount/settings',
    REQUEST_URI: '/myaccount/profile',
    BASE_URI: '/myaccount/profile',
    SETTINGS_UNSUBSCRIBE: '/myaccount/settings/notifications/marketing',
    ROUTES: {
        ACCOUNT: '/',
        UNSUBSCRIBE: '/unsubscribe',
        COOKIES: '/cookies',
        COOKIE_PREFS: '/cookies',
        NOTIFICATIONS: '/notifications',
        SECURITY: '/security',
        PAYMENTS: '/payments',
        SELLER_TOOLS: '/seller-tools',
        EMAILS: {
            ADD: '/emails/add',
            EDIT: '/emails/edit'
        },
        PASSPORT: {
            UPDATE: '/passport/update',
            DELETE: '/passport/delete',
            DELETE_SUCCESS: '/passport/delete/success',
            UPDATE_SUCCESS: '/passport/update/success'
        },
        COOKIE: {
            GET: '/cookies'
        },
        EXTEND_SESSION: '/extend-session',
        API: {
            EMAILS: {
                EDIT: '/api/emails/edit'
            },
            PASSPORT: {
                UPDATE: '/api/passport/update',
                DELETE: '/api/passport/delete'
            },
            NOTIFICATIONS: {
                UPDATE: '/api/notifications/update'
            },
            UNSUBSCRIBE: {
                UPDATE: '/api/unsubscribe/update'
            },
            COOKIES: {
                UPDATE: '/api/cookies/update',
                ACCEPT: '/api/cookies/accept'
            },
            COOKIE_PREFS: {
                UPDATE: '/api/cookiePrefs/update'
            }
        }
    },
    PAGES: {
        ACCOUNT: 'account',
        NOTIFICATIONS: 'notifications',
        SECURITY: 'security',
        PAYMENTS: 'payments',
        UNSUBSCRIBE: 'unsubscribe',
        COOKIES: 'cookies',
        UPDATE_PASSPORT: 'update-passport',
        DELETE_PASSPORT: 'delete-passport',
        UPDATE_PASSPORT_SUCCESS: 'update-passport-success',
        DELETE_PASSPORT_SUCCESS: 'delete-passport-success',
        SELLER_TOOLS: 'seller-tools'
    },
    VIEWS: {
        EMAILS: {
            ADD: 'addEmail',
            EDIT: 'editEmail'
        },
        GLOBAL_ERROR: 'globalError',
        EXTEND_SESSION: 'extendSession',
        NOTIFICATIONS: 'notifications',
        UPDATE_PASSPORT: 'update-passport',
        UPDATE_PASSPORT_SUCCESS: 'update-passport-success',
        DELETE_PASSPORT: 'delete-passport',
        DELETE_PASSPORT_SUCCESS: 'delete-passport-success',
        COOKIES: 'cookies',
        COOKIE_PREFS: 'cookiePrefs',
        SELLER_TOOLS: 'seller-tools'
    },
    FLOWS: {
        NOTIFICATIONS_PAGE: 'notifications',
        PASSPORT_PAGE: 'passportPage',
        COOKIES_PAGE: 'cookies',
        UNDEFINED: 'undefined'
    }
};
